import { config } from './config.env';

const livechat = {
    HEADER_TEXT: `LIVE CHAT`,
    ENDCHAT_TIMEOUT : 1500,
    LIVECHAT_TIMEOUT : 1000 * 60 * 20,
    RATING_TIMEOUT: 3000
} 


const acceptanceIntent = {
    DEFAULT_TIMEOUT: 3000,
    NEARBY_STORES_TIMEOUT :6000,
    ARTICLES_FOLLOWUP_DEFAULT_TIMEOUT: 3000,
    ORDERTRACKING_AUTH_TIMEOUT: 3000,
    COOLER_ARTICLE_TIMEOUT: 5000,
    SDD_ARTICLE_TIMEOUT: 5000
}

const vote = {
    QUESTION_TEXT: "Does this article help answer your question?",
    QUESTION_TEXT_ORDERTRACKING: "Does this help answer your question?",
    YES_TEXT: "\u{1F603} Yes",
    NO_TEXT: "\u{1F97A} I need help"
}

const storeConfig = {
    STORE_NUMBER_IN_CAROUSEL: 5,
    GOOGLE_MAP_API_DIRECTION_URL: "https://www.google.com/maps/dir/?api=1&destination=",
}

const dialogflowEvent = {
    End_Interaction: "End_Interaction",
    Chatbot_Additional_Questions: "Chatbot_Additional_Questions",
    Authenticated_Chatbot_Additional_Questions: "Chatbot_Authenticated_Additional_Questions",
    Chatbot_Contact_Options: "Chatbot_Contact_Options",
    Chatbot_Contact_Options_FAQList: "Chatbot_Contact_Options_FAQList",
    Authenticated_Chatbot_Contact_Options: "Chatbot_Authenticated_Contact_Options",
    Dans_Chatbot_Welcome: "Dans_Chatbot_Welcome",
    Chatbot_Article_FirstSuggestions: "Chatbot_Article_FirstSuggestions",
    KEEP_ALIVE: "KEEP_ALIVE",
    LIVECHAT_GETINTOUCH: "LIVECHAT_GETINTOUCH",
    ACCEPTANCE_RATE: "ACCEPTANCE_RATE",
    PRODUCTAVAIL_FOLLOWUP: "PRODUCTAVAIL_FOLLOWUP",
    Chatbot_FAW_Followup_Questions: "Chatbot_FAW_Followup_Questions",
    Chatbot_FAW_Try_Again: "Chatbot_FAW_Try_Again",
    Chatbot_FAW_Select_Store_Again: "Chatbot_FAW_Select_Store_Again",
    PRODUCT_AVAIL_FIND_NEARBY_STORES:"PRODUCT_AVAIL_FIND_NEARBY_STORES",
    ORDERTRACKING_AUTHENTICATED_FOLLOWUP: "ORDERTRACKING_AUTHENTICATED_FOLLOWUP",
    STORE_LOCATOR_Acceptance_Question: "STORE_LOCATOR_Acceptance_Question",
    PRODUCT_AVAIL_Acceptance_Question: "PRODUCT_AVAILABILITY_Acceptance_Question",
    ORDER_TRACKING_EXPANDEDTILE_NO: "ORDER_TRACKING_EXPANDEDTILE_NO",
    ORDER_TRACKING_EXPANDEDTILE_YES: "ORDER_TRACKING_EXPANDEDTILE_YES",
    ORDER_TRACKING_Acceptance_Question: "ORDER_TRACKING_Acceptance_Question",
    SDD_Acceptance_Question: "SDD_Acceptance_Question"
}

const orderTrackingStatusConfig = {
    CONFIRMED: "Confirmed",
    PACKED: "Packed",
    ON_ITS_WAY: "On its way",
    DELIVERED: "Delivered",
    DELIVERY_FAILED: "DeliveryFailed",
    DELIVERY_CANCELLED: "Delivery cancelled",
    DELAYED: "Delayed"
}

type statusMapping = { [key: string]: string };

const orderTrackingStatusMapping : statusMapping= { 
    "Manifest Received" : orderTrackingStatusConfig.CONFIRMED,
    "Placed" : orderTrackingStatusConfig.CONFIRMED,
    "Awaiting Pick" : orderTrackingStatusConfig.CONFIRMED,
    "Picking" : orderTrackingStatusConfig.CONFIRMED,
    "Packed" : orderTrackingStatusConfig.PACKED,
    "In transit to delivery depot" : orderTrackingStatusConfig.CONFIRMED,
    "Pickup Complete" : orderTrackingStatusConfig.PACKED,
    "Received in Depot" : orderTrackingStatusConfig.PACKED,
    "Consignment Merged" : orderTrackingStatusConfig.PACKED,
    "Out For Delivery" : orderTrackingStatusConfig.ON_ITS_WAY,
    "Consignment with Delivery Partner" : orderTrackingStatusConfig.ON_ITS_WAY,
    "Delivered - Left as Instructed" : orderTrackingStatusConfig.DELIVERED,
    "Delivered - Signed" : orderTrackingStatusConfig.DELIVERED,
    "Delivery attempt failed" : orderTrackingStatusConfig.DELIVERY_FAILED,
    "Consignment closed" : orderTrackingStatusConfig.DELIVERED,
    "Manifest Import Reversed" : orderTrackingStatusConfig.DELIVERY_CANCELLED,
    "Consignment Cancelled" : orderTrackingStatusConfig.DELIVERY_CANCELLED,
    "Consignment Confirmed" : orderTrackingStatusConfig.CONFIRMED,
    "Picking in Progress" : orderTrackingStatusConfig.CONFIRMED,
    "WithDriver" : orderTrackingStatusConfig.ON_ITS_WAY,
    "DriverNotAssigned" : orderTrackingStatusConfig.DELIVERY_CANCELLED,
    "Collected" : orderTrackingStatusConfig.ON_ITS_WAY,
    "DeliveryRequested" : orderTrackingStatusConfig.CONFIRMED,
    "DriverAssigned" : orderTrackingStatusConfig.CONFIRMED,
    "ArrivedForPickUp" : orderTrackingStatusConfig.CONFIRMED,
    "DeliveryFailed" : orderTrackingStatusConfig.DELIVERY_FAILED
}

const orderTrackingConfig = {
    QUICK_REPLY_TEXT: "View detailed tracking",
    REBOOK_REPLY_TEXT: "Rebook your delivery"
}

const zendeskErrorConfig = {
    ERROR_RESPONSE_ARRAY : ["Hmm... looks like I'm having some technical issues. Give it another try in a few minutes or reach out to the customer service team via email."
    ,"Uh oh... Looks like someone unplugged me. Please retry live chat later or leave the customer service team a message."
    ,"Oh no... Looks like someone switched around my wires and I can't connect you to live chat right now. Please try again in a few minutes or get in touch with the customer service team via email."]
}

export {
    config,
    vote,
    dialogflowEvent,
    storeConfig,
    orderTrackingStatusMapping,
    orderTrackingStatusConfig,
    livechat,
    acceptanceIntent,
    orderTrackingConfig,
    zendeskErrorConfig
}